// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const Toolbar = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 27px;
`;

export const ToolbarExpander = styled.div`
    flex-grow: 1;
`;
